import { jsxs, jsx } from "react/jsx-runtime";
import "react";
import { StaticGoogleMap, Marker } from "react-static-google-map";
import PropTypes from "prop-types";
import { useChatContext } from "../Context.js";
const RichContentMap = (props) => {
  const { chatConfiguration } = useChatContext();
  console.log(
    "chatConfiguration.googleMapsApiKey = ",
    chatConfiguration.googleMapsApiKey
  );
  return /* @__PURE__ */ jsxs(StaticGoogleMap, { size: "400x400", apiKey: chatConfiguration.googleMapsApiKey, children: [
    /* @__PURE__ */ jsx(
      Marker,
      {
        location: props.destination.latitude + "," + props.destination.longitude,
        iconURL: "https://www.dpd.co.uk/ang-component/webcomponents/general/img/google-map-marker-blue.png"
      }
    ),
    props.origin ? /* @__PURE__ */ jsx(
      Marker,
      {
        location: props.origin.latitude + "," + props.origin.longitude,
        iconURL: "https://www.dpd.co.uk/ang-component/webcomponents/general/img/google-map-marker-red.png"
      }
    ) : null
  ] });
};
RichContentMap.propTypes = {
  origin: PropTypes.object,
  destination: PropTypes.object
};
export {
  RichContentMap as default
};
//# sourceMappingURL=RichContentMap.js.map
